<template>
  <div class="downloadApp"  v-wechat-title="this.title">
    <div class="mainPage">
      <div class="caption">
          已安装APP点击更多，在浏览器中打开
      </div>
      <div class="liveMsg">
         <div class="liveImg">
          <img src="../../assets/downloadLogo.png" alt="">
         </div>
         <div class="liveName">
            <img src="../../assets/downloadIcon.png" alt="">
         </div>
      </div>
     <div class="downloadStore">
        <p  @click="downLoad()" v-if="isQQ == ''">下载APP体验</p>
        <p v-else><a :href="appsrc"  id="goTo" @click="isGoto(this)">现在就去</a></p>
     </div>
    </div>
  </div>
</template>

<script>
import cbct from '../../../static/js/base.js'
export default {
  name: 'downloadApp',
  props: {
    msg: String,
  },
  data(){
    return{
     address:'',
     title:'听见广播',
     video_id:'',//短视频id
     isFrom:'',
     is_live:'',//直播间id
     number:'',//直播间所需
     isQQ:'',//判断是否在app内
     appsrc:'',//a标签链接
    }
  },
   methods:{
     downLoad:function(){
        //android端
        if (cbct.isAndroid) {
           cbct.downLoadAndroid()
          }
        //ios端
        if (cbct.isIOS) {
          cbct.downLoadIos();
        }       
     },
     openAppAndroid(){
      this.isAndroidScheme();
      // alert("进入啊1")
      var openTime = +new Date();
      window.setTimeout(function(){
        if( (+new Date()) - openTime > 2500 ){
            cbct.downLoadAndroid()
        }
      },3000)
      // var clickedAt = +new Date;  
      // setTimeout(function(){
      //     !window.document.webkitHidden && setTimeout(function(){ 
      //           if (+new Date - clickedAt < 2000){  
      //               cbct.downLoadAndroid()
      //           }  
      //     }, 500);       
      // }, 1000)   
        
     },
    //  qq中ios点击跳转
     openAppIOS(){
          this.isIosScheme();
          setTimeout(function(){
              let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
              if(typeof hidden =="undefined" || hidden ==false){
                  cbct.downLoadIos();
              }
          }, 3000);
     },
    //  qq中点击跳转
     isGoto(){
        if(cbct.isAndroid){
          this.openAppAndroid();
        }
        if (cbct.isIOS) {
          this.openAppIOS();
        }
     },
    //  ios URL scheme地址
     isIosScheme(){
        var realsrc;
        if (this.isFrom == 'shortVideo') {
          realsrc ="SeeFMApp://shortVideo?video_id="+this.video_id
        } else if(this.isFrom == 'programRecorded' || this.isFrom == 'lifeLive') {
          realsrc ="SeeFMApp://liveVideo?number="+this.number+'&is_live='+this.is_live
        }
        window.location = realsrc;
     },
     isAndroidScheme(){
        var realsrc;
        if (this.isFrom == 'shortVideo') {
          realsrc = "seefm://cbct?video_id="+this.video_id
        } else if(this.isFrom == 'programRecorded' || this.isFrom == 'lifeLive') {
          realsrc ="seefm://cbct?live_id="+this.number+'&is_live='+this.is_live
        }
        window.location.href = realsrc;
     },
     isWeixin(){
        var u = navigator.userAgent;
        var ua = navigator.userAgent.toLowerCase();
        var isWeixin = ua.indexOf('micromessenger') != -1;
        if(ua.match(/MicroMessenger/i)=="micromessenger") {
                $('.caption').css('display','block');
        } else if (ua.match(/QQ/i) == "qq") {
               this.isQQ='1';
               if (cbct.isIOS) {
                  if (this.isFrom == 'shortVideo') {
                      this.appsrc ="SeeFMApp://shortVideo?video_id="+this.video_id
                  } else if(this.isFrom == 'programRecorded' || this.isFrom == 'lifeLive') {
                      this.appsrc ="SeeFMApp://liveVideo?number="+this.number+'&is_live='+this.is_live
                  }
               }
              if(cbct.isAndroid){
                // alert("再安卓里判断生效");
                if (this.isFrom == 'shortVideo') {
                  this.appsrc = "seefm://cbct?video_id="+this.video_id
                } else if(this.isFrom == 'programRecorded' || this.isFrom == 'lifeLive') {
                  this.appsrc ="seefm://cbct?live_id="+this.number+'&is_live='+this.is_live
                }
              }
        }else{
          if (cbct.isIOS) {
            this.isIosScheme();
          }
          if(cbct.isAndroid){
            if(u.indexOf('XiaoMi') > -1){
              // alert("小米")
              this.isQQ='1'
              if (this.isFrom == 'shortVideo') {
                this.appsrc = "seefm://cbct?video_id="+this.video_id
              } else if(this.isFrom == 'programRecorded' || this.isFrom == 'lifeLive') {
                this.appsrc ="seefm://cbct?live_id="+this.number+'&is_live='+this.is_live
              }
            }else{
               this.isAndroidScheme();
            }
          }

        }
     },
   
    
  },
  created(){
    let self =this;
    self.isFrom=self.$route.query.isFrom;
    if (self.isFrom == 'shortVideo') {
      self.video_id = self.$route.query.video_id;
    }else if(self.isFrom == 'programRecorded' || self.isFrom == 'lifeLive'){
      self.is_live = self.$route.query.is_live;
      self.number = self.$route.query.number;
    }
  },
  mounted(){
    this.isWeixin();
    $('.downloadApp').css('min-height',document.documentElement.clientHeight+'px');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.downloadApp{
  width: 100%;
  background:linear-gradient(180deg,rgba(255,223,211,1) 0%,rgba(255,255,255,1) 100%);
}
.mainPage{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background:url(../../assets/downloadBg.png) no-repeat;
  background-size: 100% 5.16rem;
}
.caption{
  position: absolute;
  right: 0.26rem;
  top: 0.08rem;
  width: 4.36rem;
  height: 0.7rem;
  line-height: 0.82rem;
  font-size:0.24rem;
  font-weight:400;
  color:rgba(255,255,255,1);
  background:url(../../assets/download1.png) no-repeat;
  background-size: 4.36rem 0.7rem;
  display: none;
}
.liveMsg{
  width: 100%;
  text-align: center;
}
.liveImg{
  width:2.36rem;
  height:3.52rem;
  margin: 1.9rem auto 2.42rem;
}
.liveImg img{
  width: 100%;
  height: 100%;
}
.liveName img{
  width: 3.96rem;
  height: 0.48rem;
}
.downloadStore{
  width:3.9rem;
  height:0.88rem;
  margin: auto;
  margin-top: 0.82rem;
}
.downloadStore p{
  width: 100%;
  height: 0.88rem;
  line-height: 0.9rem;
  background:rgba(252,64,74,1);
  border-radius:0.49rem;
  font-size:0.28rem;
  font-weight:500;
  color:rgba(255,255,255,1);
}
.downloadStore p a{
   color:rgba(255,255,255,1);
}





</style>
